import { RESOURCE_TYPE } from "../../enums";

const map = {
    [RESOURCE_TYPE.COLORS]: "colors",
    [RESOURCE_TYPE.TEXT_STYLES]: "textStyles",
    [RESOURCE_TYPE.COMPONENTS]: "componentSections",
    [RESOURCE_TYPE.COMPONENT_PAGES]: "pages"
} as const;

export default function resourceTypeToBarrelKey(resourceType: string) {
    return map[resourceType];
}
